import Vue from 'vue';
import Router from 'vue-router';
import {store} from "./store/store.js";

import AppHeader from './layout/AppHeader.vue';
import AppFooter from './layout/AppFooter.vue';
import Admin from './views/Admin.vue';
import AboutMora from "./views/AboutMora.vue";
import BookingForm from "./views/BookingForm.vue";
import Components from './views/Components.vue';
import ContactUs from "./views/ContactUs.vue";
import CounselorInformation from "./views/CounselorInformation.vue";
import EditProfile from "./views/EditProfile.vue";
import EnjoyMora from './views/EnjoyMora.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import HomePage from './views/HomePage.vue';
import Landing from './views/Landing.vue';
import Login from './views/Login.vue';
import NetworkCounselors from './views/NetworkCounselors.vue';
import NotFound from "./views/404.vue";
import MyAppointment from './views/MyAppointment.vue';
import Profile from './views/Profile.vue';
import Register from './views/Register.vue';
import RegisterPage from './views/RegisterPage.vue';
import Services from './views/Services.vue';
import ThankYou from './views/ThankYou.vue';
import ThankCounselor from './views/ThankCounselor.vue';
import TermCondition from './views/TermCondition.vue';
import ResetPassword from './views/ResetPassword.vue';
import CreateBlog from './views/CreateBlog.vue';
//Google analytics
import VueAnalytics from 'vue-analytics';

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'homepage',
      meta: {
        title: 'Home Page',
      },
      components: {
        header: AppHeader,
        default: HomePage,
        footer: AppFooter,
      },
    },
    {
      path: '/dang-ky-lam-co-van',
      name: 'dang-ky-lam-co-van',
      meta: {
        title: 'Đăng ký làm Cố vấn'
      },
      components: {
        header: AppHeader,
        default: RegisterPage,
        footer: AppFooter,
      },
    },
    {
      path: '/components',
      name: 'components',
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter,
      },
    },
    {
      path: '/landing',
      name: 'landing',
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter,
      },
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: 'Đăng nhập'
      },
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter,
      },
    },
    {
      path: '/reset_password',
      name: 'reset_password',
      meta: {
        title: 'Reset Password'
      },
      components: {
        header: AppHeader,
        default: ResetPassword,
        footer: AppFooter,
      },
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/forgot_password',
      name: 'forgot_password',
      meta: {
        title: 'Quên mật khẩu'
      },
      components: {
        header: AppHeader,
        default: ForgotPassword, 
        footer: AppFooter,
      }
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        title: 'Đăng ký tài khoản'
      },
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter,
      },
    },
    {
      path: '/about-mora',
      name: 'about-mora',
      meta: {
        title: 'Về Mora'
      },
      components: {
        header: AppHeader,
        default: AboutMora,
        footer: AppFooter
      }
    },
    {
      path: '/profile',
      name: 'profile',
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter,
      },
      meta: {
        requiresAuth: true,
        title: 'Thông tin cá nhân'
      }
    },
    {
      path: '/admin',
      name: 'admin',
      components: {
        header:   AppHeader,
        default:  Admin,
        footer:   AppFooter
      },
      meta: {
        requiresAuth: true,
        required_roles: ["admin"],
        title: 'Admin'
      },      
    },
    {
      path: '/doi-ngu-tu-van',
      name: 'doi-ngu-tu-van',
      meta: {
        title: 'Mạng lưói Cố vấn'
      },
      components: {
        header: AppHeader,
        default: NetworkCounselors,
        footer: AppFooter
      }
    },
    {
      path: '/counselor',
      name: 'counselor',
      components: {
        header: AppHeader,
        default: CounselorInformation,
        footer: AppFooter
      },meta: {
        title: 'Thông tin Cố vấn'
      },
    },
    {
      path: '/booking',
      name: 'booking',
      components: {
        header: AppHeader,
        default: BookingForm,
        footer: AppFooter
      },
      meta: {
        requiresAuth: true,
        title: 'Đặt lịch hẹn'
      },

    },
    {
      path: '/edit_profile',
      components:{
        header: AppHeader,
        default: EditProfile,
        footer: AppFooter
      },
      meta:{
        requiresAuth: true,
        title: 'Sửa thông tin cá nhân'
      }
    },
    {
      path: '/contact_us',
      components:{
        header: AppHeader,
        default: ContactUs,
        footer: AppFooter
      },
      meta: {
        title: 'Liên hệ'
      },
    },
    {
      path: '/notfound',
      components: {
        header: AppHeader,
        default: NotFound,
        footer: AppFooter
      },
      meta: {
        title: 'Not Found'
      },
    },
    {
      path: '/tro-thanh-co-van',
      components:{
        header: AppHeader,
        default: EnjoyMora,
        footer: AppFooter
      },
      meta: {
        title: 'Gia nhập mạng lưới MoraNow'
      },
    },
    {
      path: '/services',
      components:{
        header: AppHeader,
        default: Services,
        footer: AppFooter
      },
      meta: {
        title: 'Dịch vụ'
      },
    },
    {
      path: '/thankyou',
      components:{
        header: AppHeader,
        default: ThankYou,
        footer: AppFooter
      },
      meta: {
        title: 'Cảm ơn'
      },
    },
    {
      path: '/thank-counselor',
      components:{
        header: AppHeader,
        default: ThankCounselor,
        footer: AppFooter
      },
      meta: {
        title: 'Cảm ơn'
      },
    },
    {
      path: '/term-condition',
      components:{
        header: AppHeader,
        default: TermCondition,
        footer: AppFooter
      },
      meta: {
        title: 'Điều khoản sử dụng'
      }
    },    
    /*
    Wait to release
    {
      path: '/my_appointment',
      components:{
        header: AppHeader,
        default: MyAppointment,
        footer: AppFooter
      },
      meta: {
        title: 'Quản lý lịch hẹn',
        requiresAuth: true,
      }
    },
    {
      path: '/create_blog',
      components:{
        header: AppHeader,
        default: CreateBlog,
        footer: AppFooter,
      },
      meta:{
        title: 'Tạo mới bài viết',
        requiresAuth: true,
      }
    },*/
    {
      path: '*',
      redirect: '/notfound'
    }
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // console.log(s)
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['user/isAuthenticated']) {
      next()
      return        
    }
    alert('Bạn không có quyền truy cập vào nội dung này')
    next('/login') 
  } else {
    next() 
  }
})

const DEFAULT_TITLE = 'Moranow';
router.afterEach((to, from) => {
  if (to.meta.title != undefined){
    document.title = (to.meta.title + " - " +DEFAULT_TITLE)
  }else{
    document.title = DEFAULT_TITLE
  }
});

Vue.use(VueAnalytics, {
  id: 'UA-132478249-1',
  router
})

export default router;




// WEBPACK FOOTER //
// ./src/router.js